import gql from 'graphql-tag';

export const SAVE_PORTAL_CONFIGURATION = gql`
  mutation SavePortalConfiguration($input: UpsertPortalConfigurationInput!) {
    savePortalConfiguration(input: $input)
  }
`;
